import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '欧美大片推荐网站提供哪些类型的电影？',
    answer: '我们涵盖好莱坞动作大片、科幻巨制、悬疑惊悚、爱情经典、经典剧情等多种热门类型。无论你喜欢肾上腺素飙升的动作场面，还是烧脑反转的悬疑故事，都能在这里找到最适合你的欧美大片推荐。',
  },
  {
    question: '如何找到适合自己的欧美大片？',
    answer: '你可以通过首页的分类导航快速浏览不同类型的电影，也可以查看我们的经典排行和热门推荐栏目。每部电影都有详细的介绍文章，包括剧情简介、主创阵容、影片亮点等，帮助你做出观影选择。',
  },
  {
    question: '网站上的电影推荐多久更新一次？',
    answer: '我们的编辑团队每周都会更新内容，包括最新上映的好莱坞大片资讯、经典电影深度解析以及各类专题推荐。建议你定期访问或收藏本站，不错过任何精彩的欧美大片推荐。',
  },
  {
    question: '推荐的电影在哪里可以观看？',
    answer: '我们主要提供电影推荐和观影指南服务。每篇文章中会标注影片的基本信息（导演、主演、年份、时长等），你可以根据这些信息在各大正版视频平台搜索观看。我们建议通过合法渠道观看电影，支持正版内容。',
  },
  {
    question: '欧美经典大片排行的评分依据是什么？',
    answer: '我们的排行综合参考了IMDb、烂番茄、豆瓣等多个平台的评分数据，以及专业影评人和观众的综合评价。通过这些多维度的数据，我们力求为影迷提供最客观、最具参考价值的电影排行榜。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            常见<span className="text-primary-500">问题</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于欧美大片推荐的常见疑问解答
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}